import { ROLES, ROLE_PERMISSIONS } from "../adminConfig";

const readUserFromStorage = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
};

/**
 * Frontend mirror of the backend verifyAdminAccess service.
 *
 * Matches the backend logic exactly:
 *   1. SUPER_ADMIN → always allowed
 *   2. isBlockedBySuperAdmin → always denied
 *   3. user.permissions[] → server-authoritative (checked first)
 *   4. ROLE_PERMISSIONS fallback → when server didn't embed permissions
 *
 * Falls back to localStorage if user is null (context race window).
 */
export const verifyAdminAccess = (user, requiredPermission) => {
  if (!requiredPermission) return false;

  const u = user ?? readUserFromStorage();
  if (!u) return false;

  if (u.role === ROLES.SUPER_ADMIN) return true;
  if (u.isBlockedBySuperAdmin) return false;
  if (u.status === "pending" || u.status === "revoked") return false;

  const perms = Array.isArray(u.permissions)
    ? u.permissions
    : (ROLE_PERMISSIONS[u.role] || []);

  return perms.includes(requiredPermission);
};
